module.exports = __webpack_public_path__ + "img/image--205.51005a19.jpg";